import { render } from "./RequestCard.vue?vue&type=template&id=19dd2c2c&scoped=true"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"

import "./RequestCard.vue?vue&type=style&index=0&id=19dd2c2c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dd2c2c"]])

export default __exports__